import en from './en'
import hu from './hu'

export default {
    en,
    hu
}
